namespace('compass.demographic');

compass.require('compass.demographic.AddressWidget');
compass.requireLib('compass.util.parse');
compass.requireLib('compass.util.format');

compass.demographic.PaymentWidget = compass.defineWidget(function PaymentWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	/*creditCardTypes and _settings.payMethods seem to always be the same info, should probably remove the creditCardTypes entirely since payMethods is a more appropriate name*/
	var _creditCardTypesArray = options.creditCardTypes;
	var _imgPath = options.imgPath;
	var _addressWidgetJSObject = null;
	var _validator = options.validator;
	var _ISOFormat = compass.util.dateFormatter('yyyy-mm-dd');
	var _paymentIsCreditCardOnly;
	var _isCreditCardFormDrawn = false;
	var _billingNotesSelection;
	var _earnedCompsUsed = _settings.earnedCompsUsed;
	var _unsupportedPaymentMethods = ['CHECK', 'MANUAL_CHARGE'];
	var _labels = {
		security_code: {
			label: "Security Code",
			hint: "For this show, the security code on the back of the card is required"
		},
		card_type: {
			label: "",
			hint: ""
		},
		card_number: {
			label: "Credit Card Number",
			hint: "A valid credit card number is required"
		},
		experation_date: {
			label: "Expiration Date"
		},
		expiration_month: {
			hint: "A card that does not expire by the time of the reservation is required"
		},
		expiration_year: {
			hint: "A card that does not expire by the time of the reservation is required"
		},
		card_name: {
			label: "Cardholder's Name",
			hint: "A valid name on the card is required"
		},
		card_first_name: {
			label: "First Name on Card",
			hint: "A valid name on the card is required"
		},
		card_last_name: {
			label: "Last Name on Card",
			hint: "A valid name on the card is required"
		},
		payment_select: {
			label: _settings.cardWillBeCharged ? "Deposit " : "Payment "
		},
		billing_notes: {
			label: 'Billing Notes',
			hint: "A valid billing note is required"
		},
		complex_payment: {
			add_card: "Add a new credit card...",
			hint: "You must choose a payment"
		}
	};

	/* only returns those payments that are part of the permissioned array of payments acceptable for the meeting */
	var _acceptableStoredPayments = function(acceptablePaymentsArray, storedPaymentsArray){
		var acceptableStoredPaymentArray = [];

		/*filter out acceptable stored payments to only leave the pay methods the hotel being booked accepts and only if the user has permissions to that payment*/
		acceptableStoredPaymentArray = _.filter(storedPaymentsArray, function(storedPayMethod){
			return _.any(acceptablePaymentsArray, function(hotelPayMethod){
				return storedPayMethod.type === hotelPayMethod.display;
			});
		});

		/*further reject anything that is a payment required (even if the user has a permission to it) or if it is company guarantee that the user does not have a permission to*/
		acceptableStoredPaymentArray = _.reject(acceptableStoredPaymentArray, function(payment){
			return payment.type === 'Payment Required' || !payment.hasPermission;
		});

		acceptableStoredPaymentArray = acceptableStoredPaymentArray.length ? acceptableStoredPaymentArray : false;

		return acceptableStoredPaymentArray;
	};

	/* temporary. changes data to the way it looked before standardizing data schema in our views */
	if(_settings.translate)
	{
		var mapNewModelToOldModel = function(newPayment){
			return _.extend(newPayment, {
                "lastFour": newPayment.cc,
                "nameOnCard": newPayment.name_on_card,
                "paymentId": newPayment.payment_id,
                "type": newPayment.payMethodBase.name
            });
		};
		_settings.storedPayments = _.map(_settings.storedPayments, function(card,index) {
			return mapNewModelToOldModel(card);
		});

		if(_settings.currentPayment) {
			_settings.currentPayment = mapNewModelToOldModel(_settings.currentPayment);
		}
	}

	_settings.payMethods = _.reject(_settings.payMethods, function(payMethod) {
		return _.contains(_unsupportedPaymentMethods, payMethod.code);
	});

	// payment required is unique because it cannot ever be selected as a payment
	if(_settings.storedPayments) {
		/*if it's not in _settings.payMethods then we dont' want to include it in _settings.storedPayments */
		_settings.storedPayments = _acceptableStoredPayments(_settings.payMethods, _settings.storedPayments);
	}

	// company guarantee should be editable and selectable when the user has permission and should only be editable when they do not have permission
	var companyGuaranteeException = !_settings.storedPayments && _settings.currentPayment && _settings.currentPayment.type === 'Company Guarantee' && !_settings.currentPayment.hasPermission;
	var uneditableException = companyGuaranteeException || (_settings.currentPayment && _settings.currentPayment.type === 'Payment Required');

	var _skipValidation = function (input) {
		if ($(input).hasClass("hide")) {
			return _validator.IGNORED;
		}
		return _newCard ? _validator.VALID : _validator.IGNORED;
	};

	var _grabCreditCardValues = function() {
		if (!_newCard) {
			if(_settings.displaybillingNotes) {
				return { 
					"payment_id": _paymentSelection.val(),
					"billing_notes": _billingNotesSelection.val()
				};
			} else {
				return { "payment_id": _paymentSelection.val() };
			}
		}
		var values = me.find(':input,:selected').serializeArray();
		var jsonValues = {};
		jQuery.each(values, function(i, field) {
			jsonValues[field.name] = field.value;
		});

		jsonValues.address = _addressWidgetJSObject.getAddress();
		_.extend(jsonValues, _cardType(jsonValues.cardNumber));

		if(_settings.displaybillingNotes) {
			jsonValues.billingNotes = _billingNotesSelection.val();
		}
		
		return jsonValues;
	};

	me.getAddressWidgetJSObject = function() {
		return _addressWidgetJSObject;
	};

	me.isBillingAddressSameChecked = function() {
		return me.find("input[name='billingAddressSameAsMailing']").is(':checked');
	};

	var _setupControls = function() {
		var cb = me.find("input[name='billingAddressSameAsMailing']").change(function() {
			// this is not the this of this object, but the the checkbox itself since this is a callback.
			this.checked ? me.find('.addressWidgetDiv').hide() : me.find('.addressWidgetDiv').show();
		});

		var creditCardNumberField = me.find('input.cardNumberInput');
		// bind the key up event for the credit card number field to check for numeric input only
		creditCardNumberField.keyup(function(e) {
			if ( e.keyCode < 37 && e.keyCode > 40 )
				this.value = this.value.replace(/[^0-9\.]/g, '');
		});

		// bind the change event for the credit card number input to automatically change to the specific card number
		creditCardNumberField.change(function() {
			var creditCardType = _cardType(this.value);
			_changeCreditCardType(creditCardType);
		});

		var _showErrorDiv, _hideErrorDiv;
	};

	var _drawCreditCard = function() {
		var d = _d;
		_isCreditCardFormDrawn = true;

		_addressHolder = d.div({
			className : "creditCardWidgetAddressWidget subwidgetdiv creditCardWidgetAddressDiv"
		});

		var awo = _settings.addressWidget;
		awo.WUID =  me.getWUID();
		awo.validator = _validator;
		awo.skipFunc = _skipValidation;
		_addressWidgetJSObject = new compass.demographic.AddressWidget(_addressHolder, awo);

		var month = me.drawExpMonth();
		var year = me.drawExpYear();
		if (_validator) {
			_validator.addFields([month, year], [_skipValidation, _validator.CC_EXPIR], {
						minExpirDate: _settings.minExpiration,
						monthZeroIndexed: true
					});
		}
		var _expDateId = compass.generateId();
		var _expYearId = compass.generateId();

		var _uneditablePayment = (_settings.currentPayment && !_settings.currentPayment.hasPermission) && !uneditableException;
		var form = [
			_settings.displayHeader ? _drawHeader() : '',
			(_settings.storedPayments && _settings.cardHasBeenCharged === false && _paymentIsCreditCardOnly) ? _drawStoredCards() : '',
			((_settings.cardHasBeenCharged && _settings.cardHasDeposit) || _uneditablePayment) ? _drawUneditablePayment() : '',
			d.div({ className : 'creditCard'},
				d.div({ className : 'clear' }),
				d.div({ className : 'newCardFields' },
					d.div({ className: 'cardFields' },
						me.drawCardNumber(_settings.maskCCNumber),
						d.div({ className : 'beginCardImages' }),
						me.drawCardImages(),
						d.fieldset({className: 'expDate', 'aria-labelledby': _expDateId},
							d.legend({className: 'expDateLabel', id: _expDateId}, d.label({'for': _expir_ids[0]}, _labels.experation_date.label)),
							d.div({className: 'expMonthWrapper'}, month),
							d.div({className: 'expYearWrapper'}, year)
						),
						_settings.displayCVC ? me.drawSecurityCode() : null
					),
					d.div({className : 'clear'}),
					d.div({ className : 'addressFields' },
						me.drawNameOnCard(),
						_addressHolder
					),
					d.div({ className : 'clear' })
				)
			)
		];
		return form;
	};

	me.render = function(widgetElem) {
		var onlyCreditCardPayMethods = _filterPayMethods().length === 1 && _filterPayMethods()[0].display === _labels.complex_payment.add_card;
		if ((_settings.cardHasDeposit && _settings.cardHasBeenCharged) || (onlyCreditCardPayMethods && _settings.storedPayments === false)) {
			_paymentIsCreditCardOnly = true;
			widgetElem.append(_drawCreditCard());

			// wait for cardNumberInput field to be appended to paymentWidget before checking for credit card number type
			_setupControls();

			//select current year for default expiration date
			var now = new Date();
			$('.expYear option[value=' + now.getFullYear().toString() + ']').attr('selected', 'selected');

			if ((_settings.storedPayments && !uneditableException) || _settings.cardHasBeenCharged || (_settings.currentPayment && !_settings.currentPayment.hasPermission && !uneditableException)) {
				widgetElem.find(".newCardFields").hide();
			}
		} else {
			_paymentIsCreditCardOnly = false;
			_drawPaymentSelect();
		}
	};

	var _filterPayMethods = function() {
		var payMethods = _.filter(_settings.payMethods, function(payMethod) {
			return payMethod.is_credit_card === "N";
		});
		payMethods.sort().unshift({display: _labels.complex_payment.add_card, code: "__NEW__"});

		return payMethods;
	};

	var _drawExistingComplexPayment = function() {
		var storedPayments = _settings.storedPayments;

		if(_settings.currentPayment && _settings.currentPayment.hasPermission && !_.find(storedPayments, function(storedPayMethod) { return storedPayMethod.paymentId === _settings.currentPayment.paymentId })) {
			storedPayments.push(_settings.currentPayment);
		}

		var filterNonCCPayMethods = _.chain(_settings.payMethods)
			.filter(function(payMethod){ return payMethod.is_credit_card === 'N' ?  true : false; })
			.sortBy(function(payMethod){ return payMethod.display.toLowerCase(); })
			.value();

		var filterNonCCStoredPayMethods =  _.filter(storedPayments, function(storedPayMethod) {
			return storedPayMethod.lastFour === '' ?  true : false;
		});

		var CCStoredPayMethods = _.chain(storedPayments)
			.filter(function(storedPayMethod){ return storedPayMethod.lastFour === '' ?  false : true; })
			.sortBy(function(storedPayMethod){ return storedPayMethod.nameOnCard.toLowerCase(); })
			.value();

		var nonCreditCardPayMethods = [];

		/* this really just overwrites some of the information in the pay methods allowed for this hotel with information*/
		/* that is contained in payments already stored, if any*/
		_.each(filterNonCCPayMethods, function(payMethod) {
			var matchedPayMethod = _.find(filterNonCCStoredPayMethods, function(storedPayMethod) {
				return storedPayMethod.type === payMethod.display;
			});

			if(matchedPayMethod) {
				nonCreditCardPayMethods.push(matchedPayMethod);
			} else {
				nonCreditCardPayMethods.push(payMethod);
			}
		});

		return [_.map(nonCreditCardPayMethods, function(payMethod) {
				return _d.option({
					value: payMethod.paymentId ? payMethod.paymentId : payMethod.code,
					selected: payMethod.paymentId === _settings.currentPayment.paymentId
				}, payMethod.type ? payMethod.type : payMethod.display);
			}),
		_d.option({ value : '__NEW__' }, _labels.complex_payment.add_card),
		_.map(CCStoredPayMethods, function(storedCreditCard) {
			return _d.option({
				value: storedCreditCard.paymentId,
				selected: storedCreditCard.paymentId === _settings.currentPayment.paymentId
			}, storedCreditCard.nameOnCard + "'s " + storedCreditCard.type + ' ending in ' + storedCreditCard.lastFour);
		})];
	};

	var _drawInitialComplexPayment = function() {
		return [
			_d.option(),
			_.map(_filterPayMethods(), function(data, i) {
				return _d.option({
					value : data.code
				}, data.display);
			})
		];
	};

	var _drawPaymentSelect = function() {
		if(_settings.storedPayments.length > 0) {
			var _addressHolder = _d.div({
				className : "paymentSelectWidgetAddressWidget subwidgetdiv paymentSelectWidgetAddressDiv"
			});

			var awo = _settings.addressWidget;
			awo.WUID =  me.getWUID();
			_addressWidgetJSObject = new compass.demographic.AddressWidget(_addressHolder, awo);
		}

		var d = _d;
		_paymentSelection = d.select({
			name : "paymentTypeSelect",
			className : "payment paymentSelect",
			'tabindex': '0',
			'data-error-message': _labels.complex_payment.hint,
			'data-required': 'true',
			'data-parsley-required': 'true',
			'data-parsley-error-message': _labels.complex_payment.hint,
			onchange: function() {_processPaymentTypeSelectChange()}
		},  _settings.storedPayments.length > 0 ? _drawExistingComplexPayment() : _drawInitialComplexPayment()
		).data("hint", _labels.complex_payment.hint);

		var field = d.fieldLabelPair({
			className : 'paymentSelect',
			label : 'Payment'
		}, [_paymentSelection]);

		if (_validator) {
			_validator.addFields(field.find('select'), [function() {
				if(_paymentSelection) {
					return field.find('select').val() === '' ? _validator.INVALID : _validator.VALID;
				} else {
					return _validator.IGNORED;
				}
			}], {});
		}
		if (_settings.cardHasServiceFees) {
			if (_settings.cardHasBeenCharged) {
				me.getWidgetElem().append(_drawServiceFeeChargesOccurredWarning());
			} else {
				me.getWidgetElem().append(_drawServiceFeeChargesPendingWarning());
			}
		}
		me.getWidgetElem().append(field);
		if(_settings.displayEarnedComps) {
			me.getWidgetElem().append(me.drawEarnedCompsForm());
		}
		if(_settings.displayBillingNotes) {
			me.getWidgetElem().append(me.drawBillingNotes());
		}
	};

	var _processPaymentTypeSelectChange = function() {
		if (_getPaymentCodeSelected() === "__NEW__") {
			if (_settings.storedPayments.length > 0) {
				var selected = me.find('.payment.paymentSelect :selected').val();
				me.trigger('PaymentWidget.change', selected);
			}
			me.find('.paymentSelect.fieldPair').append(_drawCreditCard());
			// Wait for cardNumberInput to be appended to form before checking for card type to animate CC image fade
			_setupControls();
		} else {
			if (_isCreditCardFormDrawn) {
				_removeCreditCardFromValidation();
			}
			me.find('.creditCard').remove();
			if (_getPaymentCodeSelected() !== "") {
				me.trigger('PaymentWidget.change', selected);
			}
		}
	};

	var _processEarnedCompsChange = function() {
		var selected = me.find('.selectEarnedComps').val();
		if (parseInt(selected) !== _earnedCompsUsed && _isCreditCardFormDrawn === false) {
			me.trigger('PaymentWidget.earnedCompsChange');
		}
	};

	var _removeCreditCardFromValidation = function() {
		//by adding the class 'hide', the skipValidation function will add an ignored status
		me.find('.cardNumberInput').addClass("hide");
		me.find('.expMonth').addClass("hide");
		me.find('.expYear').addClass("hide");
		me.find('.input.nameOnCard').addClass("hide");
		me.find('.address1.address1Input').addClass("hide");
		me.find('.cityInput').addClass("hide");
		me.find('.stateSelect').addClass("hide");
		me.find('.postalCodeInput').addClass("hide");
	};

	var _getPaymentCodeSelected = function() {
		var selected = me.find('.payment.paymentSelect :selected').val();
		return selected;
	};

	me.grabValues = function() {
		var paymentInfo;
		if (_paymentIsCreditCardOnly === true || _getPaymentCodeSelected() === "__NEW__") {
			paymentInfo = _grabCreditCardValues();
			paymentInfo['is_credit_card'] = true;

		} else {
			paymentInfo = {'creditCardInfo': {}, 'is_credit_card': false};
			// check if stored card
			if(_settings.storedPayments !== false) {
				var storedPayment = _.find(_settings.storedPayments, function(storedPayMethod) {
					return storedPayMethod.paymentId.toString() === _getPaymentCodeSelected();
				});

				if(storedPayment) {
					paymentInfo['payment_id'] = storedPayment.paymentId;
				}
			}

			var selectedPayment = _.findWhere(_settings.payMethods, {code: _getPaymentCodeSelected()});
			// makes sure user did not choose empty option
			if (selectedPayment) {
				paymentInfo['code'] = selectedPayment.code;
			}
		}

		if (_settings.displayEarnedComps) {
			paymentInfo['earnedComps'] = parseInt(me.find('.selectEarnedComps').val());
		}

		if(_settings.displayBillingNotes) {
			paymentInfo['billingNotes'] = me.find('.billingNotes').val();
		}

		return paymentInfo;					
	};

	me.drawSecurityCode = function () {
		var d = _d;
		var name = 'securityCode';

		var input = d.input({
			type : 'text',
			name: name,
			className: name,
			pattern : '^[0-9]{3,4}$',
			'data-parsley-required': 'true',
			'data-parsley-error-message': _labels.security_code.hint,
			'tabindex': '0',
			autocomplete: 'off'
		}).data('hint',_labels.security_code.hint);
		var securityCodeEl = d.fieldLabelPair({
			className: name,
			label: _labels.security_code.label
		}, [
			input
		]);
		if (_validator) {
			_validator.addFields(securityCodeEl.find('input'), [_skipValidation, _validator.CC_CVC], { });
		}
		return securityCodeEl;
	};

	var _drawHeader = function () {
		return _d.div({
			className: 'creditCardHeader'
		}, 'Payment');
	};

	var _addStoredCard = me.addCard = function (card) {
		if (!_.find(_creditCardTypesArray, function (type) {
			return type.display === card.type;
		})) {
			return;
		}

		_paymentSelection.children().removeAttr('selected');

		var option = _d.option({
			value: card.paymentId,
			selected: _newCard
		}, (card.nameOnCard + "'s " + card.type + ' ending in ' + card.lastFour));
		_paymentSelection.children(':last').before(option);

		if (_newCard) {
			toggleNewFields();
		}
	};
	var _paymentSelection;
	var _drawStoredCards = function () {
		_newCard = false;
		var found = false;
		var _paymentId = compass.generateId();
		_paymentSelection = _d.select({
			className: "storedCardsSelect",
			'tabindex': '0',
			id: compass.generateId(),
			name: "storedCard",
			'ARIA-labelledby': _paymentId },
			_.map(_settings.storedPayments, function (card) {
				found = found || card.paymentId === _settings.currentPayment.paymentId;
				return _d.option({
					value: card.paymentId,
					selected: card.paymentId === _settings.currentPayment.paymentId
				}, card.nameOnCard + "'s " + card.type + ' ending in ' + card.lastFour);
			})
		).change(function(e) {
			var opt = _paymentSelection.val();
			me.trigger('PaymentWidget.change', opt);
			if(opt == '__NEW__' || _newCard) {
				toggleNewFields();
			}
		});

		if (!found && _settings.currentPayment) {
			curr = _settings.currentPayment;
			_paymentSelection.append(_d.option({
				value: curr.paymentId,
				selected: true
			}, curr.type === "Company Guarantee" ? curr.type : curr.nameOnCard + "'s " + curr.type + " ending in " + curr.lastFour));
		}
		 _paymentSelection.append(_d.option({ value : '__NEW__' }, 'Add a new credit card...'));

		return _d.div(
			{ className: 'storedCardsDiv' },
			_d.reader( _d.h4('Adjust Payment') ),
			_d.span({id: _paymentId}, _labels.payment_select.label),
			_paymentSelection
		);
	};

	var _drawServiceFeeChargesOccurredWarning = function() {
		var chargesOccurredWarningText = "You can change the card that is being used to hold the reservation, but no changes will be made to any charges that have already been made.";
		return _d.div({className: 'chargesWarning occurred'}, chargesOccurredWarningText);
	};
	
	var _drawServiceFeeChargesPendingWarning = function() {
		var chargesOccurredWarningText = "The card provided will be charged the outstanding Amount Due for the Service &amp; Technology Fee.";
		return _d.div({className: 'chargesWarning pending'}, chargesOccurredWarningText);
	};

	var _drawUneditablePayment = function() {
		var name = _settings.currentPayment.nameOnCard !== '' ? (_settings.currentPayment.nameOnCard + "'s ") : '';
		var lastFour = _settings.currentPayment.lastFour !== '' ? (" ending in " + _settings.currentPayment.lastFour) : '';
		var charged = "The deposit has been charged to ";
		var uneditable = "Payment: ";
		return _d.div({className: (_settings.cardHasBeenCharged ? "alreadyCharged" : "uneditablePayment")}, 
			_d.span((_settings.cardHasBeenCharged ? charged : uneditable) + name + _settings.currentPayment.type + lastFour + ".")
		);
	};

	var _newCard = true;
	var toggleNewFields = function () {
		_newCard = !_newCard;
		me.find(".newCardFields").slideToggle(250, function () {
			if (!_newCard) {
				me.find('.country:input').val('UNITED STATES');
				me.find('.cardImg').show();
			}
		});
	};

	var _changeCreditCardType = function(creditCardType) {
		if(creditCardType !== undefined) {
			me.find('.cardImg').show();
			// see if the credit card code matches any of the passed in credit cards and if so, select it
			for(var i=0, len=_creditCardTypesArray.length; i<len; ++i ) {
				var currentCardType = _creditCardTypesArray[i];
				var elem = me.find("img[compass-cc-code = " + currentCardType.code + "]");
				if(currentCardType.code == creditCardType.code) {
					elem.animate({ opacity : 1 }, 600);
					elem.delay(400);
					elem.show(600);
				} else {
					elem.animate({ opacity : 0.5 }, 600);
					elem.delay(400);
					elem.hide(600);
				}
			}
		} else {
			elems = me.find('.cardImg');
			elems.animate({ opacity : 1.0 }, 10);
			elems.show(400);
		}
	};

	var _drawCreditCardOptions = function() {
		var d = _d;
		var newArray = $j.map(_creditCardTypesArray,
			function(currentElement) {
				 return d.option({
					value : currentElement.value
				}, currentElement.display);
			}
		);
		return newArray;
	};

	var _findType = function(ccCode) {
		var cardType;
		for(var i=0, len=_creditCardTypesArray.length; i<len; ++i ) {
			var currentCardType = _creditCardTypesArray[i];
			if(currentCardType.code == ccCode) {
				cardType = currentCardType;
			}
		}
		return cardType;
	};

	var _cardType = function(number) {
		var cardType;
		var firstOne 		= number.substring(0,1);
		var firstTwo		= number.substring(0,2);
		var firstThree		= number.substring(0,3);
		var firstFour		= number.substring(0,4);
		var numberLength	= number.length;
		/* once we find a particular card type, we return it if we find it in the list of valid payments passed into this widget, undefined otherwise */
		switch(numberLength) {
			case 15: {
				if(firstTwo == '34' || firstTwo == '37') {
					cardType = _findType('AM');
				}
				break;
			}
			case 13: {
				if(firstOne == '4') {
					cardType = _findType('DS');
				}
				break;
			}
			case 16: {
				if(firstFour == '6011') {
					cardType = _findType('DS');
				}
				if(parseInt(firstTwo) >= 51 && parseInt(firstTwo) <= 55) {
					cardType = _findType('MC');
				}
				if(firstOne == '4') {
					cardType = _findType('VI');
				}
				break;
			}
			case 14: {
				/* Diners Club card numbers begin with 300 through 305, 36 or 38. All have 14 digits */
				if((parseInt(firstThree) >= 300 && parseInt(firstThree) <= 305) || (firstTwo == '36' || firstTwo == '38')){
					cardType = _findType('DC');
				}
				break;
			}
		}

		return cardType;
	};

	me.drawCardType = function() {
		var d = _d;

		return d.fieldLabelPair({
			className : 'cardType',
			label : 'card type:'
		}, d.select({
			name : "cardType",
			className : "cardType cardTypeSelect"
		}, _drawCreditCardOptions()));
	};

	me.drawCardNumber = function(maskCCNumber) {
		var d = _d;

		var showCardNumber = function(maskCCNumber) {
			if (maskCCNumber) {
				var gen_id = compass.generateId();
				return d.div({ className: 'showCardNumber'},
					[d.label({ 'for': gen_id }, 'Show card number'), d.input({
						type: 'checkbox',
						className: 'showCardNumberCheckbox',
						name: 'showCardNumber',
						'tabindex': '0',
						id: gen_id
					}).change(function() {
						$('.cardNumberInput.unmasked').toggleClass('hide');
						$('.cardNumberInput.masked').toggleClass('hide');
					})]
				);
			}
			else {
				return '';
			}
		};

		var hiddenField = d.input({
			className : 'cardNumberHidden',
			type : 'hidden',
			name : 'cardNumber',
			'tabindex': '-1',
			'aria-hidden': 'true'
		});

		var inputs = [d.input({
			type : 'text',
			className : 'cardNumberInput cardNumber unmasked ' + (maskCCNumber ? 'hide' : ''),
			name : "cardNumberDummy",
			pattern : '[0-9]*',
			'tabindex': '0',
			'data-parsley-luhn': 'true',
			'data-parsley-cctype': 'true',
			'data-parsley-required': 'true',
			'data-parsley-error-message': _labels.card_number.hint,
			autocomplete: 'off'
		}).data("hint", _labels.card_number.hint)
			.change(function(){
				hiddenField.val($j(this).val());
				$('.cardNumberInput.cardNumber.masked').val($j(this).val());
			}),
		d.input({
			type : 'password',
			className : 'cardNumberInput cardNumber masked ' + (maskCCNumber ? '' : 'hide'),
			name : "cardNumberDummyMasked",
			pattern : '[0-9]*',
			'tabindex': '0',
			'data-parsley-luhn': 'true',
			'data-parsley-cctype': 'true',
			'data-parsley-required': 'true',
			'data-parsley-error-message': _labels.card_number.hint,
			autocomplete: 'off'
		}).data("hint", _labels.card_number.hint)
			.change(function(){
				hiddenField.val($j(this).val());
				$('.cardNumberInput.cardNumber.unmasked').val($j(this).val());
			}),
		showCardNumber(maskCCNumber)
		];

		var field = d.fieldLabelPair({
			className : 'cardNumber',
			label : _labels.card_number.label
		}, inputs);

		var label_id = compass.generateId();
		field.find('.cardNumber.fieldLabel').attr('for', label_id);
		_.each(inputs, function (elem) { $(elem).attr({'aria-labelledby': label_id, 'id': label_id}); });

		if (_validator) {
			_.each(field.find("input:not(:checkbox)"), function (input) {
				_validator.addFields($(input), [_skipValidation, _validator.CC], {"allowedCCTypesArray" : _creditCardTypesArray});
			});
		}
		return d.div({ className: 'cardNumberWrapper'}, [field, hiddenField]);
	};

	me.drawCardImages = function() {
		var d = _d;

		var thumbnailArray = $j.map(_creditCardTypesArray,
			function(currentElement) {
				if (currentElement.code === '' || currentElement.is_credit_card === 'N' || currentElement.is_credit_card === false) { return; }
				currentElement.fileName = currentElement.code;

				// If psd2 is on, use updated card images
				if(_settings.display2FA === true) {
					if(currentElement.code === 'MC') {
						currentElement.fileName = 'MC-id-check';
					} else if(currentElement.code === 'VI') {
						currentElement.fileName = 'VI-secure';
					}
				} 

				return d.div({className: _settings.display2FA ? 'cardImgDiv _2FA' : 'cardImgDiv'}, d.img({
					className : _settings.display2FA ? 'cardImg _2FA' : 'cardImg',
					"compass-cc-code" : currentElement.code,
					src : _imgPath + currentElement.fileName + '.png'
				}));
			}
		);

		return _d.div({
			className : "cardImgDivs"
		}, thumbnailArray);
	};

	var _expir_val_flag = false;
	window.Parsley.addValidator('ccexpiration', {
		validateString: function (val, expDate, elem) {
			var $elem = elem.$element;
			var year, month, assoc;
			var mElem = me.find('.expMonth');
			var yElem = me.find('.expYear');
			var mElem = $elem.attr("data-parsley-month"),
				yElem = $elem.attr("data-parsley-year");

			var mLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
			if (mElem) {
				year = parseInt(val, 10);
				assoc = $("#" + mElem);
				month = parseInt(assoc.val(), 10)-1;
			} else if (yElem) {
				month = parseInt(val, 10)-1;
				assoc = $("#" + yElem);
				year = parseInt(assoc.val(), 10);
			} else {
				return false;
			}

			expDate = compass.util.parse.ISODateParser(expDate);
			var currDate = new Date(year, month, mLength[month]);

			var res = currDate.valueOf() >= expDate.valueOf();
			if (!_expir_val_flag) {
				_expir_val_flag = true;
				assoc.parsley('needsValidation', true); // Change flag that says to rerun validation
				assoc.parsley().validate();
				_expir_val_flag = false;
			}

			return res;
        }
    });

	window.Parsley
	    .addValidator('luhn', function (val, elem) {
	        {
				val = val.replace(/[ -]/g, '');
				var digit, n, sum, _j, _len1, _ref2;
				sum = 0;
				_ref2 = val.split('').reverse();
				for (n = _j = 0, _len1 = _ref2.length; _j < _len1; n = ++_j) {
					digit = _ref2[n];
					digit = +digit;
					if (n % 2) {
						digit *= 2;
						if (digit < 10) {
							sum += digit;
						} else {
							sum += digit - 9;
						}
					} else {
						sum += digit;
					}
				}
				return sum % 10 === 0;
	        }
	    });

	window.Parsley
	    .addValidator('cctype', function (val, elem, self) {
	        {
				var type = _cardType(val);
				return type !== undefined;
	        }
	    });

	var _expir_ids = [compass.generateId(), compass.generateId()];
	me.drawExpMonth = function() {
		var d = _d;
		var mName = compass.util.dateFormatter('mmmm');
		return d.select({
			name : "expMonth",
			className : "expMonth expMonthSelect",
			id: _expir_ids[0],
			'tabindex': '0',
			'data-parsley-ccexpiration': _ISOFormat(_settings.minExpiration),
			'data-parsley-year': _expir_ids[1],
			'data-parsley-error-message': _labels.expiration_month.hint,
			'aria-label': 'month'
		}, $j.map(["1-Jan", "2-Feb", "3-Mar", "4-Apr", "5-May", "6-Jun", "7-Jul", "8-Aug", "9-Sep", "10-Oct", "11-Nov", "12-Dec"], function(data, i) {
			return d.option({
				value : data.substring(0,data.indexOf('-')),
				'aria-label' : mName(new Date(2014, i, 1))
			}, data.toString());
		})).data("hint", _labels.expiration_month.hint);
	};

	me.drawExpYear = function() {
		var d = _d;
		var now = new Date();
		return d.select({
			name : "expYear",
			className : "expYear",
			'tabindex': '0',
			id: _expir_ids[1],
			'data-parsley-ccexpiration': _ISOFormat(_settings.minExpiration),
			'data-parsley-month': _expir_ids[0],
			'data-parsley-error-message': _labels.expiration_year.hint,
			'aria-label': 'year'
		}, $j.map(_.range(now.getFullYear(), now.getFullYear()+11), function(data, i) {
			return d.option({
				value : data
			}, data.toString());
		}) // make the start year and number of year options...with basic option.
		).data("hint", _labels.expiration_year.hint);
	};

	me.drawNameOnCard = function() {
		var d = _d;
		var field;
		var _nameOnCardChange = function() {
			var firstName = me.find('.input.firstNameOnCard').val();
			var lastName = me.find('.input.lastNameOnCard').val();
			me.find('.input.nameOnCard').val(firstName + " " + lastName);
		};
		if(_settings.displayFirstLastName) {
			field = [
				d.fieldLabelPair({
					className : 'firstNameOnCard',
					label : _labels.card_first_name.label
				}, [d.input({
					name : "firstNameOnCard",
					className : "input firstNameOnCard",
					type : "text",
					id : compass.generateId(),
					'tabindex': '0',
					'data-parsley-required': 'true',
					'data-parsley-error-message': _labels.card_first_name.hint,
					'data-parsley-pattern': /[^\d\s\.\/\-]/,  //Contains at least 1 letter
					autocomplete: 'off'
				}).data("hint", _labels.card_first_name.hint)]).on('input propertychange', function(e) { _nameOnCardChange(); }),
				d.fieldLabelPair({
					className : 'lastNameOnCard',
					label : _labels.card_last_name.label
				}, [d.input({
					name : "lastNameOnCard",
					className : "input lastNameOnCard",
					type : "text",
					id : compass.generateId(),
					'tabindex': '0',
					'data-parsley-required': 'true',
					'data-parsley-error-message': _labels.card_last_name.hint,
					'data-parsley-pattern': /[^\d\s\.\/\-]/,  //Contains at least 1 letter
					autocomplete: 'off'
				}).data("hint", _labels.card_last_name.hint)]).on('input propertychange', function(e) { _nameOnCardChange(); }),
				d.input({
					name : "nameOnCard",
					className : "input nameOnCard",
					type : "hidden",
					id : compass.generateId(),
					autocomplete: 'off'
				})
			];
		} else {
			field = d.fieldLabelPair({
				className : 'nameOnCard',
				label : _labels.card_name.label
			}, [d.input({
				name : "nameOnCard",
				className : "input nameOnCard",
				type : "text",
				id : compass.generateId(),
				'tabindex': '0',
				'data-parsley-required': 'true',
				'data-parsley-error-message': _labels.card_name.hint,
				'data-parsley-pattern': /[^\d\s\.\/\-]/,  //Contains at least 1 letter
				autocomplete: 'off'
			}).data("hint", _labels.card_name.hint)]);
		}
		if (_validator) {
			_validator.addFields(field.find('input'), [_skipValidation, _validator.NAME], { });
		}
		return field;
	};

	me.drawBillingAddressSameAsMailingCheckbox = function() {
		var d = _d;
		return d.fieldLabelPair({
			className : 'billingAddressSameAsMailing',
			label : 'billing address same as mailing?:'
		}, [d.input({
			name : "billingAddressSameAsMailing",
			className : "billingAddressSameAsMailing",
			'tabindex': '0',
			type : "checkbox"
		})]);
	};

	me.drawBillingNotes = function() {
		_billingNotesSelection = _d.textarea({ 
			className : 'billingNotes', 
			maxlength:350,
			'data-parsley-required': 'false',
			'data-parsley-error-message': _labels.billing_notes.hint,
			'data-parsley-pattern': /[^\d\s\.\/\-]/  //Contains at least 1 letter
		}, _settings.billingNotes).on('input propertychange', function(e) {
			me.trigger('PaymentWidget.change', _billingNotesSelection.val());
		});

		return [
			_d.fieldLabelPair({ className : 'billingNotesPair', label : _labels.billing_notes.label }, _billingNotesSelection), 
			_d.div({className : 'clear'})
		];
	};

	me.drawEarnedCompsForm = function() {
		var selectEarnedComps = me.drawEarnedCompsSelect(_settings.arriveDate, _settings.departDate);
		var earnedComps = _d.div({ className: 'earnedComps', 'data-required': 'true'}, 'Apply ', selectEarnedComps, ' complimentary nights out of the ' + _settings.availableEarnedComps + ' available to date.*',
						  _d.span({ className: 'finePrintEarnedComps'}, '*Final earned comp night amounts may differ, based on actualized room night pick up.'));
		return earnedComps;
	};

	me.drawEarnedCompsSelect = function(arrive, depart) {
		var numNights = me.getReservationLength(arrive, depart);
		var selectOptions = [];
		for (i = 0; i <= numNights; i++) {
			selectOptions.push(i);
		}

		var selectEarnedComps = _d.select({
			className: 'selectEarnedComps',
			onchange: function() {_processEarnedCompsChange()}
		}, _.map(selectOptions, function(option) {
				return _d.option({
					value: option,
					selected: _earnedCompsUsed === option
				}, option.toString());
			})
		);

		return selectEarnedComps;
	};

	me.getReservationLength = function(arrive, depart) {
		var arrive = new Date(arrive);
		var depart = new Date(depart);
		var numNights = parseInt((depart - arrive) / (1000 * 60 * 60 * 24));
		return numNights;
	};

	me.processStayChange = function(arrive, depart) {
		var selectEarnedComps = me.find('.selectEarnedComps');
		var newStayLength = me.getReservationLength(arrive, depart);
		var appliedEarnedComps = parseInt(selectEarnedComps.val());

		if (newStayLength >= appliedEarnedComps) {
			_earnedCompsUsed = appliedEarnedComps;
			selectEarnedComps.replaceWith(me.drawEarnedCompsSelect(arrive, depart));
		} else if (newStayLength < appliedEarnedComps) {
			_earnedCompsUsed = newStayLength;
			selectEarnedComps.replaceWith(me.drawEarnedCompsSelect(arrive, depart));
		}

	};

	me.disable = function() {
		_paymentSelection.attr('disabled', true);
	};

	me.enable = function() {
		_paymentSelection.attr('disabled', false);
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'CRAP',
	widgetName : 'PaymentWidget',
	imgPath : compass.staticPrefix + '/resources/img/compass/demographic/CreditCardWidget/',
	subclass : false,
	displayHeader: false,
	displayCVC : false,
	storedPayments: false,
	addressWidget : {},
	minExpiration: new Date(),
	maskCCNumber: false,
	cardWillBeCharged: false,
	cardHasBeenCharged: false,
	billingNotes: '',
	displaybillingNotes: false,
	displayEarnedComps: false,
	display2FA: false,
	displayFirstLastName: false
});

